import { ChatState, ExistThreadEventCapturedPayload } from '../types'

export const onExistThreadEventCaptured = (
  state: ChatState,
  { conversation }: ExistThreadEventCapturedPayload
): ChatState => {
  const conversations: ChatState['conversations'] = {
    ...state.conversations,
    [conversation.id]: conversation,
  }

  return {
    ...state,
    conversations,
  }
}
